<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <nx-bform-radio-group
      :name="name"
      :rules="{ required }"
      :options="[
        { text: $t('mr'), value: 'Mr' },
        { text: $t('mrs'), value: 'Mrs' },
        { text: $t('ms'), value: 'Ms' },
        { text: $t('miss'), value: 'Miss' }
      ]"
      :value="$attrs.value"
      @input="$listeners.input"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("nameTitle");
    }
  }
};
</script>

<i18n src="@/locales/registration.locale"></i18n>

<i18n src="@/locales/common.locale"></i18n>
